module.exports = __webpack_public_path__ + "media/images/videos/suns-f673ad0d5d4933772c37cc012117df04.mp4";